import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-write-in-dialog',
    imports: [MatDialogModule, FormsModule],
    templateUrl: './write-in-dialog.component.html',
    styleUrls: ['./write-in-dialog.component.scss']
})
export class WriteInDialogComponent {
  userInput: string = '';
  errorMessage: string = ''; 
  maxLength: number = 80;
  inputError = false

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: any,
    private dialogRef: MatDialogRef<WriteInDialogComponent>
  ) {
    if (data) {
      this.userInput = data.description || '';
    }
  }
  validateInput() {
    if (this.userInput.length > this.maxLength) {
      this.errorMessage = $localize`Maximum allowed length is ${this.maxLength} characters.`;
      this.inputError = true
    } else if (!this.noSpecialChars(this.userInput)) {
      this.errorMessage = $localize`Special characters are not allowed.`;
      this.inputError = true
    } else {
      this.errorMessage = '';
      this.inputError = false
    }
  }


  noSpecialChars(value: string): boolean {
    const validNamePattern = /^[^{\}\(\)\[\]\+\*\?\^\$\|\\]*$/;
    return validNamePattern.test(value);
  }

  closeDialog() {
    if (this.errorMessage) {
      this.dialogRef.close({ error: this.errorMessage }); 
    } else {
      this.dialogRef.close({ result: this.userInput }); 
    }
  }

  cancelDialog(){
    this.dialogRef.close({ }); 
  }
}
